
export default

    class User {

    constructor(id, name, cpf, drive_license, email, phone, birthday, manager_id, id_address, user_address=[], clientsUser=[], profile_id = null) {
        this.id = id
        this.name = name
        this.cpf = cpf
        this.drive_license = drive_license
        this.email = email
        this.manager_id = manager_id
        this.clientsUser = clientsUser
        this.phone = phone
        this.birthday = birthday
        this.id_address = id_address
        this.userAddress = user_address
        this.hasForPasswordChange = true
        this.profile_id = profile_id
    }
}

class Profile {

    constructor(id, description) {
        this.id = id
        this.description = description
    }
}